export const FETCH_SETTINGS_SUCCESS = 'fetchsettingsSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_SETTINGS_M = 'updateActiveSortFieldSettingsMutation';
export const UPDATE_SEARCH_SETTINGS_M = 'updateSearchSettingsMutation';
export const CLEAR_SEARCH_SETTINGS_M = 'clearSearchSettingsMutation';
